import { render } from "./MelatiStep.vue?vue&type=template&id=4e4de0dd&scoped=true&ts=true"
import script from "./MelatiStep.vue?vue&type=script&lang=ts"
export * from "./MelatiStep.vue?vue&type=script&lang=ts"

import "./MelatiStep.vue?vue&type=style&index=0&id=4e4de0dd&lang=scss&scoped=true"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4de0dd"]])

export default __exports__